import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=007b1b10&scoped=true&"
import script from "./Editor.vue?vue&type=script&lang=js&"
export * from "./Editor.vue?vue&type=script&lang=js&"
import style0 from "./Editor.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Editor.vue?vue&type=style&index=1&id=007b1b10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007b1b10",
  null
  
)

export default component.exports